module.exports = __webpack_public_path__ + "static/media/basket.cf07bfe8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/basket.svg
// module id = 461
// module chunks = 0